module.exports = __webpack_public_path__ + "static/media/ico-hfeatured-arrow-left.d65115c3.svg";